export enum FeatureFlags {
  Housing = 'OpcoSquareHasMyHousingModule',
  Expenses = 'OpcoSquareHasMyExpensesModule',
  Balance = 'OpcoSquareHasMyBalanceModule',
  Work = 'OpcoSquareHasMyWorkModule',
  TimeRegistration = 'OpcoSquareHasTimeRegistrationModule',
  Requests = 'OpcoSquareRequestTimeOffEnabled',
  FeedbackWeek = 'OpcoSquareFeedbackWeekEnabled',
  FeedbackApplication = 'OpcoSquareFeedbackApplicationEnabled',
  Payslips = 'OpcoSquareHasPayslips',
  Invoices = 'OpcoSquareHasInvoices',
  InvitationId = 'OpcoSquareRequiredInvitationIdForOnboardingEnabled',
  Calendar = 'OpcoSquareHasMyCalendarModule',
  PublicJobSearch = 'OpcoSquareHasPublicJobSearchModuleEnabled',
  Shifts = 'OpcoSquareHasMyShiftsModule',
  Job = 'OpcoSquareHasMyJobSearchModule',
  JobHasFiltersEnabled = 'OpcoSquareHasMyJobSearchFiltersEnabled',
  EventCalendar = 'OpcoSquareHasEventCalendarModule',
  WhatsAppPhoneVerification = 'OpcoSquareIsWhatsAppPhoneVerificationEnabled',
  RegisterWizard = 'OpcoSquareHasRegisterWizardEnabled',
  MarketingConsent = 'OpcoSquareHasMarketingConsentEnabled',
};

export type FeatureFlag = {
  name: FeatureFlags;
  isEnabled: boolean;
};
